import { render, staticRenderFns } from "./work-select-modal.vue?vue&type=template&id=2818305b&scoped=true"
import script from "./work-select-modal.vue?vue&type=script&lang=js"
export * from "./work-select-modal.vue?vue&type=script&lang=js"
import style0 from "./work-select-modal.vue?vue&type=style&index=0&id=2818305b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818305b",
  null
  
)

export default component.exports